import { render, staticRenderFns } from "./set-password.page.vue?vue&type=template&id=ee0f4da0&scoped=true&"
import script from "./set-password.page.vue?vue&type=script&lang=js&"
export * from "./set-password.page.vue?vue&type=script&lang=js&"
import style0 from "./set-password.page.vue?vue&type=style&index=0&id=ee0f4da0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0f4da0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
